/**
 * @voltxampere/ui — Magnetic reed switch (Sprint 51-1 polish)
 *
 * Magnetically-actuated mechanical switch (NO contacts, normally
 * open). Closes when permanent magnet brought near (~5-15mm).
 * Used in door/window security sensors, position detectors, simple
 * RPM tachometers (magnet on rotating shaft + reed switch nearby).
 *
 * Engine zero-diff invariant honored — schemaType `switch` (Sprint 22
 * canonical type).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const switchReedMagnetic = {
    id: "reed-switch-magnetic",
    nameTr: "Reed Anahtar (mıknatıs ile)",
    nameEn: "Magnetic Reed Switch",
    shortcut: "S",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "SW",
    defaultValue: "NO",
    schemaType: "switch",
    defaultParams: {
        state: "open",
        rOn: 0.05,
        rOff: 1e9,
        contactType: "NO",
        actuationDistanceMm: 10,
        operateTimeMs: 1,
        contactRatingMa: 500,
    },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=switch-reed-magnetic.js.map